import { User, UserRole } from '../../types';

// Mock Users
export const mockUsers: User[] = [
  {
    id: '1',
    name: 'John Doe',
    email: 'john.doe@openana.com',
    role: UserRole.Admin,
    avatar: 'https://mui.com/static/images/avatar/1.jpg',
  },
  {
    id: '2',
    name: 'Jane Smith',
    email: 'jane.smith@openana.com',
    role: UserRole.Editor,
    avatar: 'https://mui.com/static/images/avatar/2.jpg',
  },
  {
    id: '3',
    name: 'Bob Johnson',
    email: 'bob.johnson@openana.com',
    role: UserRole.Viewer,
    avatar: 'https://mui.com/static/images/avatar/3.jpg',
  },
  {
    id: '4',
    name: 'Sarah Williams',
    email: 'sarah.williams@openana.com',
    role: UserRole.InvestmentAnalyst,
    avatar: 'https://mui.com/static/images/avatar/4.jpg',
  },
  {
    id: '5',
    name: 'Michael Brown',
    email: 'michael.brown@openana.com',
    role: UserRole.VP,
    avatar: 'https://mui.com/static/images/avatar/5.jpg',
  },
  {
    id: '6',
    name: 'Emily Davis',
    email: 'emily.davis@openana.com',
    role: UserRole.Partner,
    avatar: 'https://mui.com/static/images/avatar/6.jpg',
  },
];
